import { easepick } from "@easepick/core";
import { DateTime, LockPlugin, RangePlugin } from "@easepick/bundle";

// https://easepick.com/guide/
// https://easepick.com/packages/datetime.html
// https://easepick.com/packages/lock-plugin.html

const pickerElement = document.getElementById("date-range-picker");
const trigger = document.querySelector<HTMLElement>(".style-guide-form-elements #date-range-picker-trigger");

if (pickerElement && trigger) {
    /**
     * mock booked data
     */
    const bookedDates = [
        ["2023-02-06", "2023-02-11"],
        "2023-02-18",
        "2023-02-19",
        "2023-02-20",
        "2023-02-25",
        "2023-02-28",
        ["2023-03-04", "2023-03-17"]
    ].map((d) => {
        if (d instanceof Array) {
            const start = new DateTime(d[0], "YYYY-MM-DD");
            const end = new DateTime(d[1], "YYYY-MM-DD");

            return [start, end];
        }

        return new DateTime(d, "YYYY-MM-DD");
    });

    const picker = new easepick.create({
        element: pickerElement,
        css: [pickerElement.dataset.cssPath],
        zIndex: 200000,
        grid: 2,
        calendars: 2,
        inline: false,
        readonly: false,
        autoApply: false,
        lang: pickerElement.dataset.lang,
        locale: {
            cancel: pickerElement.dataset.cancel,
            apply: pickerElement.dataset.apply
        },
        plugins: [RangePlugin, LockPlugin],
        RangePlugin: {
            tooltip: false,
            repick: true,
            strict: false
        },
        LockPlugin: {
            minDate: new Date(),
            inseparable: true,
            filter: (date: DateTime) => date.inArray(bookedDates)
        }
    });

    trigger.addEventListener("click", picker.show.bind(picker));
    picker.on("hide", () => {
        const startDate = picker.getStartDate();
        const endDate = picker.getEndDate();
        if (startDate && endDate) {
            const startPresentation = startDate.format("DD.MM.YY");
            const endPresentation = endDate.format("DD.MM.YY");
            trigger.dataset.start = startDate.format("YYYY-MM-DD");
            trigger.dataset.end = endDate.format("YYYY-MM-DD");
            trigger.querySelector<HTMLSpanElement>(".date.start .label").dataset.date = startPresentation;
            trigger.querySelector<HTMLSpanElement>(".date.end .label").dataset.date = endPresentation;
        }
    });
}

/**
 * DateTime.(inArray|isBetween) inclusivity argument is not documented
 * @see: https://github.com/easepick/easepick/blob/4a49a0f029551aabb9f890d8458b0d7a2046842e/packages/datetime/src/index.ts#L290
 * "(" : date is > midnight
 * "[" : date is >= midnight
 * ")" : date is < midnight
 * "]" : date is <= midnight
 *
 * argument is a combined string like e.g. "[)" : date is >= midnight of date1 and is < midnight of date2
 */
